<template>
  <div class="min-height-300 bg-primary position-absolute w-100"></div>
  <!-- Sidebar -->
<!--   <aside
    class="
      sidenav
      bg-white
      navbar navbar-vertical navbar-expand-xs
      border-0 border-radius-xl
      my-3
      fixed-start
      ms-4
    "
    id="sidenav-main"
  >
  <div class="sidenav-header">
      <i
        class="
          fas
          fa-times
          p-3
          cursor-pointer
          text-secondary
          opacity-5
          position-absolute
          end-0
          top-0
          d-none d-xl-none
        "
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <a class="navbar-brand m-0" href="" target="#">
        <img
          src="/assets/img/logo-ct-dark.png"
          class="navbar-brand-img h-100"
          alt="main_logo"
        />
        <span class="ms-1 font-weight-bold">Enjoy</span>
      </a>
    </div>
    <hr class="horizontal dark mt-0" />
    <div class="collapse navbar-collapse w-auto" id="sidenav-collapse-main">
      <ul class="navbar-nav">
        <li class="nav-item">

        </li>
      </ul>
      </div>




  </aside> -->
  <!-- <Sidebar /> -->
  <!-- End Sidebar -->

  <main class="main-content position-relative border-radius-lg">
    <!-- Navbar -->
    <Navbar className="container py-1 px-3">
      <template v-slot:breadcrumb><slot name="breadcrumb"></slot></template>
      <template v-slot:header><slot name="header"></slot></template>
    </Navbar>
    <!-- End Navbar -->

    <div class="container">
      <!--Content-->

      <flash-message v-if="$page.props.flash"></flash-message>

      <slot name="content"></slot>

      <!--End Content-->

      <!----footer-->
      <Footer />
      <!----footer-->
    </div>
  </main>
</template>

<script>
import Footer from "@/Components/Footer";
import Navbar from "@/Components/Navbar";
import Sidebar from "@/Components/Sidebar";
import FlashMessage from "@/Components/FlashMessage";
export default {
  components: {
    Footer,
    Navbar,
    Sidebar,
    FlashMessage,
  },
};
</script>
